export const marcoOpSesa_item = [
  {
    marcoOpSesa_item_instrumento: "REGLAMENTO INTERIOR SESA",
    marcoOpSesa_item_years: [
      {
        marcoOpSesa_item_year: "2025",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2023/Reglamento Interior Julio 2023.pdf"> REGLAMENTO INTERIOR JUL 2023</a>
        /*"Contenido para el año 6 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2024",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2023/Reglamento Interior Julio 2023.pdf"> REGLAMENTO INTERIOR JUL 2023</a>
        /*"Contenido para el año 6 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2023",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2022/Reglamento Interior Enero 2022.pdf"> REGLAMENTO INTERIOR ENE 2022</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2023/Reglamento Interior Julio 2023.pdf"> REGLAMENTO INTERIOR JUL 2023</a>,
        ] /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2022",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2022/Reglamento Interior Enero 2022.pdf"> REGLAMENTO INTERIOR ENE 2022</a>
        /*"Contenido para el año 6 del Instrumento 1",*/
      },  
      {
        marcoOpSesa_item_year: "2021",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/Reglamento Int  jul 2017.pdf"> REGLAMENTO INTERIOR JUL 2017</a>
        /*"Contenido para el año 6 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2020",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/Reglamento Int  jul 2017.pdf"> REGLAMENTO INTERIOR JUL 2017</a>
        /*"Contenido para el año 5 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2019",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/Reglamento Int  jul 2017.pdf"> REGLAMENTO INTERIOR JUL 2017</a> 
        /*"Contenido para el año 4 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2018",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/Reglamento Int  jul 2017.pdf"> REGLAMENTO INTERIOR JUL 2017</a>
        /*"Contenido para el año 3 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2017",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/Reglamento Int 29 de sept 2014.pdf"> REGLAMENTO INTERIOR SEP 2014</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/Reglamento Int  jul 2017.pdf"> REGLAMENTO INTERIOR JUL 2017</a>,
        ] /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSesa_item_year: "2016",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/Reglamento Int 29 de sept 2014.pdf"> REGLAMENTO INTERIOR SEP 2014LA</a>
        /*"Contenido para el año 1 del Instrumento 1",*/
      },
      // Agrega más años si es necesario
    ],
  },
  {
    marcoOpSesa_item_instrumento: "ESTRUCTURA ORGÁNICA SESA",
    marcoOpSesa_item_years: [
      {
        marcoOpSesa_item_year: "2025",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2023/ESTRUCTURA SESA SEP 2023.pdf"> ESTRUCTURA SEP 2023</a> 
        /*"Contenido para el año 6 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2024",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2023/ESTRUCTURA SESA SEP 2023.pdf"> ESTRUCTURA SEP 2023</a> 
        /*"Contenido para el año 6 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2023",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/ESTRUCTURA SESA 2019.pdf"> ESTRUCTURA JUL 2019</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2023/ESTRUCTURA SESA SEP 2023.pdf"> ESTRUCTURA SEP 2023</a>,
       ]
        /*"Contenido para el año 2 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2022",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/ESTRUCTURA SESA 2019.pdf"> ESTRUCTURA JUL 2019</a> 
        /*"Contenido para el año 6 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2021",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/ESTRUCTURA SESA JUL 2017.pdf"> ESTRUCTURA JUL 2017</a> 
        /*"Contenido para el año 6 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2020",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/ESTRUCTURA SESA JUL 2017.pdf"> ESTRUCTURA JUL 2017</a> 
        /*"Contenido para el año 5 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2019",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/ESTRUCTURA SESA JUL 2017.pdf"> ESTRUCTURA JUL 2017</a> 
        /*"Contenido para el año 4 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2018",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/ESTRUCTURA SESA JUL 2017.pdf"> ESTRUCTURA JUL 2017</a>
        /*"Contenido para el año 3 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2017",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/ESTRUCTURA ABR 2016.pdf">ESTRUCTURA ABR 2016</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2017/ESTRUCTURA SESA JUL 2017.pdf"> ESTRUCTURA JUL 2017</a>,
       ]
        /*"Contenido para el año 2 del Instrumento 2",*/
      },
      {
        marcoOpSesa_item_year: "2016",
        marcoOpSesa_item_contenido: [
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/ESTRUCTUCTURA OCT 2013.jpg">ESTRUCTURA OCT 2013</a> ,
        <br></br>,
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/ESTRUCTURA ABR 2016.pdf">ESTRUCTURA ABR 2016</a>,
      ]/*"Contenido para el año 1 del Instrumento 2",*/
      },
      // Agrega más años si es necesario
    ],
  },
  {
    marcoOpSesa_item_instrumento: "MANUAL DE ORGANIZACIÓN SESA",
    marcoOpSesa_item_years: [
      {
        marcoOpSesa_item_year: "2025",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2024/MANUAL ORGANIZACION JULIO 2024.pdf">MANUAL ORGANIZACIÓN JULIO 2024</a>,
        ] 
        /*"Contenido para el año 4 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2024",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2024/MANUAL ORGANIZACION JULIO 2024.pdf">MANUAL ORGANIZACIÓN JULIO 2024</a>,
        ] 
        /*"Contenido para el año 4 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2023",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>
        /*"Contenido para el año 6 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2022",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>
        /*"Contenido para el año 5 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2021",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>
        /*"Contenido para el año 6 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2020",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>
        /*"Contenido para el año 5 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2019",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL ORGANIZACION AGOSTO 2016.pdf">MANUAL ORGANIZACIÓN AGOSTO 2016</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL ORGANIZACION AGOSTO 2019.pdf">MANUAL ORGANIZACIÓN AGOSTO 2019</a>,
        ] 
        /*"Contenido para el año 4 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2018",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL ORGANIZACION AGOSTO 2016.pdf">MANUAL ORGANIZACIÓN AGOSTO 2016</a> 
        /*"Contenido para el año 3 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2017",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL ORGANIZACION AGOSTO 2016.pdf">MANUAL ORGANIZACIÓN AGOSTO 2016</a> 
        /*"Contenido para el año 2 del Instrumento 3",*/
      },
      {
        marcoOpSesa_item_year: "2016",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL ORGANIZACION AGOSTO 2016.pdf">MANUAL ORGANIZACIÓN AGOSTO 2016</a> 
        /*"Contenido para el año 1 del Instrumento 3",*/
      },
      // Agrega más años si es necesario
     
    ],
  },
  {
    marcoOpSesa_item_instrumento: "MANUAL DE PROCEDIMIENTOS SESA",
    marcoOpSesa_item_years: [
      {
        marcoOpSesa_item_year: "2025",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2025/MANUAL DE PROCEDIMIENTOS ENERO 2025.pdf"> MANUAL DE PROCEDIMIENTOS ENERO 2025</a>
        /*"Contenido para el año 6 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2024",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL DE PROCEDIMIENTOS AGOSTO 2019.pdf"> MANUAL DE PROCEDIMIENTOS AGOSTO 2019</a>
        /*"Contenido para el año 6 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2023",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL DE PROCEDIMIENTOS AGOSTO 2019.pdf"> MANUAL DE PROCEDIMIENTOS AGOSTO 2019</a>
        /*"Contenido para el año 6 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2022",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL DE PROCEDIMIENTOS AGOSTO 2019.pdf"> MANUAL DE PROCEDIMIENTOS AGOSTO 2019</a>
        /*"Contenido para el año 6 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2021",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL DE PROCEDIMIENTOS AGOSTO 2019.pdf"> MANUAL DE PROCEDIMIENTOS AGOSTO 2019</a>
        /*"Contenido para el año 6 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2020",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL DE PROCEDIMIENTOS AGOSTO 2019.pdf"> MANUAL DE PROCEDIMIENTOS AGOSTO 2019</a>
        /*"Contenido para el año 5 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2019",
        marcoOpSesa_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL DE PROCEDIMIENTOS NOV 2016.pdf">MANUAL DE PROCEDIMIENTOS NOV 2016</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2019/MANUAL DE PROCEDIMIENTOS AGOSTO 2019.pdf"> MANUAL DE PROCEDIMIENTOS AGOSTO 2019</a>,
        ] 
        /*"Contenido para el año 4 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2018",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL DE PROCEDIMIENTOS NOV 2016.pdf">MANUAL DE PROCEDIMIENTOS NOV 2016</a>
        /*"Contenido para el año 3 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2017",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL DE PROCEDIMIENTOS NOV 2016.pdf">MANUAL DE PROCEDIMIENTOS NOV 2016</a>
        /*"Contenido para el año 2 del Instrumento 4",*/
      },
      {
        marcoOpSesa_item_year: "2016",
        marcoOpSesa_item_contenido: <a target="_blank" href="/contenido/informacion/instrumentonormativoSESA/A2016/MANUAL DE PROCEDIMIENTOS NOV 2016.pdf">MANUAL DE PROCEDIMIENTOS NOV 2016</a>
        /*"Contenido para el año 1 del Instrumento 4",*/
      },
      // Agrega más años si es necesario
    ],
  },
  // Agrega más instrumentos si es necesario
];
